export enum ApiUrlEnum {
  allUsers = '/users/all',
  editUsers = '/users/:id',
  createUsers = '/users/create',
  statsTotal = '/stats/total',
  statsTotalTypes = '/stats/totalfiletypes',
  filetypes = '/stats/filetypes',

  weeklyStats = '/stats/weekly',
  allFolders = '/folders',
  getLast6Folders = '/folders/getLast6Folders',
  pathFolders = '/folders/path/:id',
  allFiles = '/files',
  getLast6Files = '/files/getLast6Files',
  folderChildren = '/folders/children/:id',
  pathFiles = '/files/path/:id',
  uploadFiles = '/files/uploadfiles',
  repalceFile = '/files/replace/:id',
  emptyFile = '/files/emptyFile',
  deleteFiles = '/files/:id',
  deleteFolder = '/folders/:id',
  editFolder = '/folders/:id',
  copyfile = '/files/copy',
  editFile = '/files/:id',
  oneFile = 'files/:id',
  parseIndicators = '/files/parseIndicator/:id',
  programs = '/programs',
  editprograms = '/programs/:id',

  volets = '/volets',
  editvolets = '/volets/:id',
  composants = '/composant',
  metric = '/metric/:id',
  impact = '/impact',
  editimpact = '/impact/:id',
  editproduct = '/product/:id',
  editEffect = '/effect/:id',

  programxvolet = '/impact/programxvolet',
  editComposants = '/composant/:id',

  //Carbon
  carbon = '/carbon',
  yearlyStats = '/carbon/stats',
  programYearlyStats = '/carbon/stats-program',
  carbonStats = '/carbon/stats/all',
  programCarbonStats = '/carbon/stats/program/all',

  //history
  allHistory = '/history',
  //simulate
  simulate = '/simulate',
}
